import React, { useState, useEffect } from "react";

import failIcon from "./icon_fail.png";
import successIcon from "./icon_success.png";
import queryString from "query-string";
import API_URL from "../components/ApiUrl";
import { useTranslation } from "react-i18next";

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [httpStatus, setHttpStatus] = useState(500);
  const [loading, setLoading] = useState(true);
  const parsed = queryString.parse(window.location.search);
  console.log(parsed);
  const token = parsed.token;

  useEffect(() => {
    fetch(`${API_URL}/users/verify-email?token=${token}`)
      .then((response) => {
        console.log(response);
        setHttpStatus(response.status);
      })
      .catch((error) => {
        console.error(error);
        setHttpStatus(401);
      })
      .finally(() => setLoading(false)); // Set loading to false regardless of fetch outcome
  }, [token]);

  if (loading) {
    return (
      <div className="content">
        <p>Loading...</p>
      </div>
    );
  } else if (httpStatus === 204) {
    return (
      <div className="content">
        <img src={successIcon} className="Leader-icon" alt={t('success')} />
        <h1>{t('verify.success.title')}</h1>
        <p>
          {t('verify.success.body.1.1')} <br />
          {t('verify.success.body.1.2')} </p>
        <></>
        <p>
          {t('verify.success.body.2.1')} <br />
          {t('verify.success.body.2.2')} </p>
        <></>
        <p>{t('contact.title')}</p>
        <a href="tel:0800300766">{t('contact.body')}</a>
        <></>
        <p>
          {t('thank.1')} <br />
          {t('thank.2')} </p>
      </div>
    );
  } else {
    return (
      <div className="content">
        <img src={failIcon} className="Leader-icon" alt={t('fail')} />
        <h1>{t("verify.fail.title")}</h1>
        <p>
          {t('verify.fail.body.1.1')} <br />
          {t('verify.fail.body.1.2')} </p>
        <></>
        <p>{t('verify.fail.body.2')}</p>
        {t('contact.title')} <a href="tel:0800300766">{t('contact.body')}</a>
        <></>
        <p>
          {t('thank.1')} <br />
          {t('thank.2')} </p>
      </div>
    );
  }
};

export default VerifyEmail;
